import '../register-service-worker';
import '../display-guest-or-user-content';

import mainNavigation from '../main-navigation';
import optionsOutput from '../option-outputs';
import carousel from '../carousel';
import commonActions from '../actions-common';

mainNavigation.init();
optionsOutput.init();
carousel.init();
commonActions.init();
